// @ts-nocheck
import { Plugin } from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request','qiankun',],
});

export { plugin };
